<template>
  <div>
    <section class="hero has-shadow is-grey-ligth">
      <div class="hero-head" style="margin-bottom: 20px;">
        <br />
        <div
          class="container is-flex is-justify-between"
          style="align-items: center; margin: 0px 25px 0 13px;"
        >
          <h1
            class="title has-text-weight-bold has-text-dark is-2"
            style="margin-bottom: 0; text-wrap: nowrap;"
          >
            Líderes PHD
          </h1>
          <div
            v-if="tokenUser && tokenUser.admin"
            class="text-card"
            v-tooltip.bottom="{
              content: empresa.nombre,
              trigger: isMovil ? 'click' : 'manual',
            }"
          >
            <span class="is-size-6 w-full truncate">{{ empresa.nombre }}</span>
            <p
              v-if="proceso.nombre !== '.....'"
              class="is-size-5 has-text-weight-bold truncate"
            >
              {{ proceso.nombre }}
            </p>
          </div>
        </div>
      </div>
      <div class="hero-foot">
        <!-- Menu -->
        <nav class="tabs is-boxed">
          <div class="container">
            <ul v-if="!isMovil">
              <li
                v-bind:class="{ 'is-active': activo('yProceso') }"
                @click="selectSection({ d: 'yProceso', name: 'Proceso' })"
              >
                <a href="#">Proceso</a>
              </li>
              <li
                v-bind:class="{ 'is-active': activo('yEmpleados') }"
                @click="selectSection({ d: 'yEmpleados', name: 'Empleados' })"
              >
                <a href="#">Empleados</a>
              </li>
              <li
                v-bind:class="{ 'is-active': activo('yAjustes') }"
                v-if="tokenUser ? tokenUser['admin'] : false"
                @click="selectSection({ d: 'yAjustes', name: 'Configuración' })"
              >
                <a href="#">Configuración</a>
              </li>
              <li
                v-bind:class="{ 'is-active': activo('yRelaciones') }"
                @click="selectSection({ d: 'yRelaciones', name: 'Relaciones' })"
              >
                <a href="#">Relaciones</a>
              </li>
              <li
                v-bind:class="{ 'is-active': activo('yResumen') }"
                @click="selectSection({ d: 'yResumen', name: 'Resumen' })"
              >
                <a>Resumen</a>
              </li>
              <li
                v-bind:class="{
                  'is-active': activo('yResultado') || activo('yGuide'),
                }"
                @click="selectSection({ d: 'yGuide', name: 'Guia' })"
              >
                <a href="#">Resultados</a>
              </li>
              <li
                v-bind:class="{ 'is-active': activo('yFiles') }"
                @click="selectSection({ d: 'yFiles', name: 'Anexos' })"
              >
                <a href="#">Anexos</a>
              </li>
            </ul>
            <ul v-if="isMovil">
              <li
                class="is-active"
                v-on:click="showMenuMobile = !showMenuMobile"
              >
                <a href="javascript:void(0)" class="is-flex">
                  {{ title }}
                  <span class="icon is-small">
                    <i class="material-icons">expand_more</i>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </section>
    <div
      style="display: flex;
      justify-content: left;
      margin-left: 40px;
      text-align: center;"
    >
      <!-- Mobile -->
      <div
        v-if="isMovil"
        class="dropdown"
        :class="showMenuMobile ? 'is-active' : ''"
      >
        <div class="dropdown-menu" role="menu">
          <div class="dropdown-content">
            <a
              href="#"
              class="dropdown-item"
              v-bind:class="{ 'is-active': activo('yProceso') }"
              @click="selectSection({ d: 'yProceso', name: 'Proceso' })"
            >
              Proceso
            </a>
            <a
              class="dropdown-item"
              v-bind:class="{ 'is-active': activo('yEmpleados') }"
              @click="selectSection({ d: 'yEmpleados', name: 'Empleados' })"
            >
              Empleados
            </a>
            <a
              href="#"
              class="dropdown-item"
              v-bind:class="{ 'is-active': activo('yAjustes') }"
              v-if="tokenUser ? tokenUser['admin'] : false"
              @click="selectSection({ d: 'yAjustes', name: 'Configuración' })"
            >
              Ajustes
            </a>
            <a
              href="#"
              class="dropdown-item"
              v-bind:class="{ 'is-active': activo('yRelaciones') }"
              @click="selectSection({ d: 'yRelaciones', name: 'Relaciones' })"
            >
              Relaciones
            </a>
            <a
              href="#"
              class="dropdown-item"
              v-bind:class="{ 'is-active': activo('yResumen') }"
              @click="selectSection({ d: 'yResumen', name: 'Resumen' })"
            >
              Resumen
            </a>
            <a
              href="#"
              class="dropdown-item"
              v-bind:class="{
                'is-active': activo('yResultado') || activo('yGuide'),
              }"
              @click="selectSection({ d: 'yGuide', name: 'Guia' })"
            >
              Resultados
            </a>
            <a
              href="#"
              class="dropdown-item"
              v-bind:class="{ 'is-active': activo('yFiles') }"
              @click="selectSection({ d: 'yFiles', name: 'Anexos' })"
            >
              Anexos
            </a>
          </div>
        </div>
      </div>
    </div>
    <section
      class="is-fullheight is-fullwidth"
      :class="{ colums: !activo('yGuide') }"
      style="transition: all 0.3s ease 0s !important;"
    >
      <div
        :class="{ 'container colum': !activo('yGuide') }"
        style="transition: all 0.3s ease 0s !important;"
      >
        <div
          :class="{
            container: !activo('yGuide'),
            'container-guie': activo('yGuide'),
          }"
          v-if="tokenUser"
        >
          <component
            ref="content"
            :is="select"
            :proceso="proceso"
            :process="proceso"
            :tokenUser="tokenUser"
            @selproceso="selproceso"
            @selectSection="selectSection"
            @traerelaciones="traerelaciones"
            @calculateProcess="calculateProcess"
          ></component>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import yResumen from "@/components/lideres/Resumen.vue";
import yProceso from "@/components/lideres/Proceso.vue";
import yEmpleados from "@/components/lideres/Empleados.vue";
import yRelaciones from "@/components/lideres/Relaciones.vue";
import yGuide from "./GuiaInterpretacion.vue";
import yResultado from "@/components/lideres/Resultados.vue";
import yFiles from "@/components/attached/uploadFilesBoard.vue";
import yAjustes from "@/components/lideres/Ajustes/Ajustes.vue";
import apiServices from "@/services/yungol-services";
import { mapState } from "vuex";

export default {
  data() {
    return {
      select: "yProceso",
      title: "Proceso",
      showMenuMobile: false,
      proceso: {
        nombre: ".....",
      },
      relaciones: [],
    };
  },
  computed: {
    ...mapState(["tokenUser", "isOculto", "isMovil", "empresa"]),
  },
  methods: {
    selproceso(d, p) {
      this.proceso = d;
      if (Object.keys(p).length > 0) {
        this.proceso.processComp = p;
      }
      setTimeout(
        this.selectSection({ d: "yEmpleados", name: "Empleados" }),
        5000,
      );
    },
    selectSection({ d, name }) {
      if (this.proceso.nombre !== ".....") {
        if (d === "yEmpleados") {
          this.select = d;
          this.title = name;
          this.traerelaciones();
        } else if (d === "yResultado") {
          let terminado = this.relaciones.filter(
            (r) => r["status"] === "calculado",
          ).length;
          if (terminado > 3) {
            this.select = d;
            this.title = name;
          } else {
            this.$store.dispatch("notify", {
              message: `Los colaboradores no han respondido lo suficiente`,
              type: "is-danger",
            });
          }
        } else {
          this.select = d;
          this.title = name;
        }
        this.closeMenuMobile();
      } else {
        this.$store.dispatch("notify", {
          message: `Selecciona un proceso`,
          type: "is-danger",
        });
        this.closeMenuMobile();
      }
    },
    activo(a) {
      return a === this.select;
    },
    async traerelaciones() {
      this.relaciones = [];
      let result;
      try {
        result = await apiServices.get(
          `/listliderrelacion/${this.proceso._id}`,
        );
        if (result.data) {
          this.relaciones = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    closeMenuMobile() {
      this.showMenuMobile = false;
    },
    async calculateProcess() {
      let result;
      const d = {
        id: this.proceso._id,
      };
      try {
        result = await apiServices.post(`/calcular`, d);

        if (result.data !== "Sin datos para calcular") {
          await this.traerelaciones();
          await this.$emit("traerelaciones");
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  components: {
    yResumen,
    yProceso,
    yEmpleados,
    yRelaciones,
    yGuide,
    yResultado,
    yFiles,
    yAjustes,
  },
};
</script>

<style lang="scss" scoped>
.contenedor {
  width: 100%;
  position: absolute;
  z-index: 1;
}

.contenedor2 {
  width: 90%;
  position: absolute;
  z-index: 1;
}

.container-guie {
  margin-top: 10px;
}

a.dropdown-item.is-active,
button.dropdown-item.is-active {
  background-color: #522687;
  color: #fff;
}

.tabs.is-toggle li.is-active a {
  background-color: #522687;
  border-color: #905fbf;
  color: white;
  z-index: 1;
}

.hero.is-grey-ligth .tabs.is-boxed li.is-active a {
  background-color: white;
  border: solid 0 white;
  color: #522687 !important;
  box-shadow: #00000029 0px 14px 20px;
}

.hero.is-grey-ligth .tabs.is-boxed li:hover a {
  background-color: rgba(191, 191, 191, 0.475);
  border: solid 0 rgba(191, 191, 191, 0.475) !important;
  color: #522687 !important;
}

.hero.is-grey-ligth {
  padding-left: 40px;
}

.hero.is-grey-ligth .tabs.is-boxed a {
  border: 0px solid transparent;
  border-radius: 4px 4px 0 0;
}

.text-card {
  padding: 3px 10px;
  border-radius: 10px;
  background-color: white;
}

@media (max-width: 768px) {
  .text-card {
    max-width: 55vw;
    min-width: 0;

    .truncate {
      display: block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .title.is-2 {
      font-size: 2rem !important;
    }

    .is-size-6,
    .is-size-5 {
      font-size: 0.75rem !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/lideres/Liderv1.vue